export default {
  buttons: {
    signup: "S'inscrire",
    login: 'Se connecter',
  },
};
